function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = [
    "href"
];
import { ElButton } from 'element-plus';
import 'element-plus/es/components/button/style/css'

import { ref, useAttrs } from 'vue';
export default /*@__PURE__*/ _defineComponent(_object_spread_props(_object_spread({}, {
    inheritAttrs: false
}), {
    __name: 'IButton',
    props: {
        type: {
            default: ''
        },
        nativeType: {
            default: 'button'
        },
        size: {
            default: ''
        },
        href: {
            default: ''
        },
        flexible: {
            type: Boolean
        },
        center: {
            type: Boolean
        }
    },
    setup (__props) {
        const attrs = useAttrs();
        const isShowRipple = ref(false);
        const onMouseDown = ()=>{
            if (attrs.disabled) {
                return;
            }
            isShowRipple.value = true;
        };
        const onAnimationEnd = ()=>{
            isShowRipple.value = false;
        };
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock("div", {
                class: _normalizeClass([
                    _ctx.$style.wrapper,
                    __props.flexible && _ctx.$style.flexible,
                    __props.center && _ctx.$style.center
                ]),
                onMousedown: onMouseDown
            }, [
                __props.href ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: __props.href,
                    class: _normalizeClass([
                        'el-button',
                        __props.type && `el-button--${__props.type}`,
                        __props.size && `el-button--${__props.size}`,
                        _unref(attrs).disabled && 'is-disabled',
                        _ctx.$style.link
                    ])
                }, [
                    _renderSlot(_ctx.$slots, "default")
                ], 10, _hoisted_1)) : (_openBlock(), _createBlock(_unref(ElButton), _mergeProps({
                    key: 1,
                    type: __props.type,
                    "native-type": __props.nativeType,
                    size: __props.size,
                    class: _ctx.$style.button
                }, _unref(attrs)), {
                    default: _withCtx(()=>[
                            _renderSlot(_ctx.$slots, "default")
                        ]),
                    _: 3
                }, 16, [
                    "type",
                    "native-type",
                    "size",
                    "class"
                ])),
                _cache[0] || (_cache[0] = _createTextVNode()),
                isShowRipple.value ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(_ctx.$style.ripple),
                    onAnimationend: onAnimationEnd
                }, null, 34)) : _createCommentVNode("", true)
            ], 34);
        };
    }
}));
